module.exports = __webpack_public_path__ + "img/1526566795.83f61441.jpg";